import { e as t } from "./index819.mjs";
import { f as s } from "./index758.mjs";
import { g as a } from "./index767.mjs";
var r = t, e = s, i = a, m = i.String, f = !!Object.getOwnPropertySymbols && !e(function() {
  var o = Symbol("symbol detection");
  return !m(o) || !(Object(o) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && r && r < 41;
});
export {
  f as s
};
